import React from 'react';

const SvgRoundExclamation = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 36 36"
    {...props}
  >
    <g id="Group_72" data-name="Group 72" transform="translate(-911 -184)">
      <circle
        id="Ellipse_1"
        data-name="Ellipse 1"
        cx="18"
        cy="18"
        r="18"
        transform="translate(911 184)"
        fill="#fff"
      />
      <path
        id="round-error-24px"
        d="M12.8,17.8A1.805,1.805,0,0,1,11,16V8.8a1.8,1.8,0,0,1,3.6,0V16A1.805,1.805,0,0,1,12.8,17.8ZM14.6,25H11V21.4h3.6Z"
        transform="translate(916 186)"
        fill="#8c6f45"
      />
    </g>
  </svg>
);
export default SvgRoundExclamation;
